import algoliasearch from 'algoliasearch/lite';
import {ReactElement} from 'react';
// @ts-ignore:next-line
import {InstantSearch} from 'react-instantsearch';

/**
 * https://www.algolia.com/doc/guides/building-search-ui/what-is-instantsearch/react-hooks/
 */

export const algoliaClient = algoliasearch(
  'NIWLYC4KOA', // App ID
  '6e03f2490c272cccc3ef08691043d68c', // This is the public API key which can be safely used in your frontend code. This key is usable for search queries and it's also able to list the indices you've got access to.
);

// A wrapper to return empty results when empty query is given.
// This basically just disables the initial request to Algolia.
// https://www.algolia.com/doc/guides/building-search-ui/going-further/conditional-requests/react-hooks/
const searchClient = {
  ...algoliaClient,
  search(requests: any) {
    if (requests.every(({params}: {params: any}) => !params.query)) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
          hitsPerPage: 0,
          exhaustiveNbHits: false,
          query: '',
          params: '',
        })),
      });
    }

    return algoliaClient.search(requests);
  },
};

// For some reason we get a warning if we don't provide a default index name for InstantSearch
export const productsIndexName =
  import.meta.env.PUBLIC_SANITY_DATASET === 'production'
    ? 'shopify_products'
    : 'dev_shopify_products';

export function AlgoliaProvider({children}: {children: ReactElement}) {
  return (
    <InstantSearch searchClient={searchClient} indexName={productsIndexName}>
      {children}
    </InstantSearch>
  );
}
